import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess,} from '../../actions/datasources/schedule'
import config from '../../../config'; // Adjust the path based on where the file is located
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error'

function* process(data) {
  const { datasource_id, action } = data.payload; // Extract page and rowsPerPage from the action
  let response = null;
  try {
    if (action === 'start') {
      response = yield call(
        axios.get,
        `${config.API_URL}/datasource/schedule_datasource/${datasource_id}`,
        { headers: getLocalUser() }
      );
    } else if (action === 'stop') {
      response = yield call(
        axios.get,
        `${config.API_URL}/datasource/stop_datasource/${datasource_id}`,
        { headers: getLocalUser() }
      );
    }
    yield put(fetchSuccess({...response.data.data, action}));
    yield put({ type: 'SHOW_SUCCESS_SNACKBAR', message: `datasource ${datasource_id} ${action}ed successfully`});


  } catch (error) {
    if (action === 'start') {
      // error.toString()
      yield put(fetchSuccess({...error.response.data.data, action: 'stop'}));
    } else {
      yield put(fetchSuccess({...error.response.data.data, action: 'start'}));
    }
    yield put({ type: 'SHOW_ERROR_SNACKBAR', message: `Could not ${action} datasource ${datasource_id}. ${error.toString()}`});

  }
}

export function* watch() {
  yield takeEvery(REQUEST, process);
}
